const EDITOR_CLIENT = 'northstar-editor';
const EDITOR_RETURN_PATH = /^\/simulation\/editor\/(?:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/?)?$/;

/** Keep Editor context only for an exact, same-site Editor destination. */
export function deviceLinkContext(searchParams: URLSearchParams) {
  const code = (searchParams.get('code') || '').trim();
  const clients = searchParams.getAll('client');
  const destinations = searchParams.getAll('returnUrl');
  const editorReturnPath = clients.length === 1 && clients[0] === EDITOR_CLIENT
    && destinations.length === 1 && EDITOR_RETURN_PATH.exec(destinations[0])?.[0] === destinations[0]
    ? destinations[0] : null;
  const preserved = new URLSearchParams();
  if (code) preserved.set('code', code);
  if (editorReturnPath) {
    preserved.set('client', EDITOR_CLIENT);
    preserved.set('returnUrl', editorReturnPath);
  }
  const query = preserved.toString();
  return { code, editorReturnPath, selfPath: `/link${query ? `?${query}` : ''}` };
}
